import { showAlert } from "@/shared/store/alertStore";
import i18n from "@/shared/config/i18n";
import { tokenStorage } from "@/shared/auth/tokenStorage";

/**
 * Безопасное скачивание файла с авторизацией.
 * Берёт `file.file_url` (относительный путь от backend) и подставляет Bearer-токен.
 * При ошибке показывает alert вместо тихого window.open, чтобы пользователь
 * не получил незаавторизованный 401-ответ в новой вкладке.
 */
export async function downloadFileSecure(file) {
  if (!file?.file_url) {
    showAlert(
      i18n.global.t("Ошибка"),
      i18n.global.t("Не удалось определить путь к файлу"),
      "error"
    );
    return;
  }

  const base = window.__CONFIG__?.VUE_APP_BASE_DOMAIN || "";
  const path = /^https?:\/\//i.test(file.file_url)
    ? file.file_url
    : `${base}${file.file_url}`;

  const token = tokenStorage.accessToken;
  const headers = token ? { Authorization: `Bearer ${token}` } : {};

  let blob;
  try {
    const res = await fetch(path, { headers, credentials: "include" });
    if (!res.ok) {
      throw new Error(`HTTP ${res.status}`);
    }
    blob = await res.blob();
  } catch (e) {
    showAlert(
      i18n.global.t("Ошибка"),
      i18n.global.t("Не удалось скачать файл"),
      "error"
    );
    console.error("[downloadFileSecure] failed", e);
    return;
  }

  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = file.file_name || "file";
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}
